import React, {useState} from 'react';
import PropTypes from 'prop-types';
import ReactPhoneInput from '@talal7860/react-phone-input-2';
import { omit, isNull } from 'lodash/fp';
import incorrectIcon from '../new-icons/incorrect-icon.svg';
import '@talal7860/react-phone-input-2/dist/style.css';
import styled, { css } from 'styled-components';
import {Asterisk} from "../pages/contact-details";


const NumberContainer = styled.div`
  display:flex !important;
  justify-content: flex-end !important;
  flex-direction: row !important;
  align-items: center !important;

  .react-tel-input{
    width: 99%;
  }
  ${props => !props.validationClass && css`
  input:focus{
     box-shadow: 0 0 0 0.09rem ${props.primaryColor} !important;
  }
  `}
.form-control.is-invalid, .was-validated .form-control:invalid {
    border-color: #dc3545;
    padding-right: calc(1.5em + .75rem);
    background-image: url(${incorrectIcon}) !important;
    background-repeat: no-repeat;
    background-position: center right calc(.375em + .1875rem);
    background-size: calc(.45em + .75rem) calc(.45em + .375rem);
}
 .react-tel-input .country-list{
  font-size: 13px;
  text-align:left;
  .search-box{
   width: 93%;
  }
  }
  ${({ width }) => (width === 'w-50') && `
    width: 50%;
  `}
  ${({ width }) => (width === 'w-100') && `
    width: 100%;
  `}
  @media (max-width: 575px){
    width: 100%;
  }
`;

export const CheckMark = styled.div`
  position: absolute;
  right: 15px;
  top: 8px;
  z-index: 1;
  display: inline-block;
  transform: rotate(45deg);
  height: 15px;
  width: 8px;
  border-bottom: 3px solid ${(props) => props.common ? props.common.waveformColor : '#00B54B'};
  border-right: 3px solid ${(props) => props.common ? props.common.waveformColor : '#00B54B'};
`;

const PhoneNumber = (props) => {
    const {
        value, onChange, country, width,validate,common,phoneDigits, countryCode,
    } = props;
    const [touched, setTouched] = useState(false);
    let validationClass = '';
    if (!validate) {
        if ((isNull(phoneDigits) || !touched) && !country) {
            validationClass = '';
        } else if (country) {
            validationClass = 'is-invalid';
        } else if (phoneDigits) {
            validationClass = 'is-valid';
        }
    }
    const onBlur = (e) => {
        setTouched(true);
        props.onBlur(e);
    };
    // eslint-disable-next-line max-len
    // Updated:  defaultCountry option is 'us', In case if we get code from API GET_IP_COUNTRY then edit field is not workable
    // const { data } = useQuery(GET_IP_COUNTRY);
    return (
        <NumberContainer primaryColor={common.buttonColor}
                         validationClass={validationClass}
                         width={width} className="input-group">
            {validationClass === 'is-valid' ? <CheckMark common={common}/> : '' }
            <ReactPhoneInput
                excludeCountries={[
                    'ir',
                    'kp',
                    'sy',
                    'sd',
                    've',
                    'cu',
                    'ci',
                    'by',
                    'iq',
                    'lr',
                    'zw',
                    'mm',
                ]}
                preferredCountries={[
                    'us',
                    'gb',
                    'fr',
                    'de',
                    'es',
                    'nz',
                    'za',
                    'au',
                ]}
                preserveOrder={['onlyCountries', 'preferredCountries']}
                defaultCountry={countryCode}
                placeholder="Your phone number"
                searchPlaceholder="Type to search"
                buttonClass="btn-countries"
                disableAreaCodes
                enableSearchField
                inputClass={`w-100 form-control ${validationClass}`}
                {...omit(['error', 'className', 'value', 'onBlur'], props)}
                onBlur={onBlur}
                value={value}
                onChange={onChange}
                disabled={false}
                enableLongNumbers
                searchClass="country-selector-search"
                countryCodeEditable={true}
                SearchIcon={() => <i className="fas fa-search" />}
            />
            <Asterisk visible={common.phoneRequired} btmDis>*</Asterisk>
        </NumberContainer>
    );
};

PhoneNumber.propTypes = {
    country: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    onBlur: PropTypes.func,
    width: PropTypes.string,
    validate: PropTypes.number,
};

PhoneNumber.defaultProps = {
    country: '',
    disabled: false,
    onBlur: () => {},
    width: '',
    validate: 0,
};

export default PhoneNumber;
